/* Tool rail (W2-03): 48 px icons, 120 px with labels in Guided. Tokens only. */

.rail {
  display: flex;
  flex-direction: column;
  width: 48px;
  height: 100%;
  padding: var(--space-2) var(--space-1);
  overflow-y: auto;
  background: var(--color-surface-1);
  border-right: var(--border-width) solid var(--color-divider);
}

.labelled {
  width: 120px;
}

.toolbar {
  align-items: center;
}

.labelled .toolbar {
  align-items: stretch;
}

.active {
  background: var(--color-accent-muted);
  color: var(--color-accent);
  box-shadow: inset 0 0 0 var(--border-width) var(--color-accent-border);
}

.labelButton {
  justify-content: flex-start;
  width: 100%;
}
